//Author June Leow
//Date Mar 22nd, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const unitViewDescriptionTypeEnum = [
  {value:'NONE_NOTABLE',label:'None Notable'},
  {value:'VACANT_LOT',label:'Vacant Lot'},
  {value:'WOODS_TREED_PRIVATE',label:'Wood Treed Private'},
  {value:'HILLS_FOOTHILLS',label:'Hills Foothill'},
  {value:'GREENBELT_OPEN_SPACE',label:'Greenbelt Open Space'},
  {value:'MOUNTAIN',label:'Mountain'},
  {value:'MOUNTAIN_RANGE',label:'Mountain Range'},
  {value:'POND',label:'Pond'},
  {value:'LAKE',label:'Lake'},
  {value:'CANAL',label:'Canal'},
  {value:'OCEAN',label:'Ocean'},
  {value:'RIVER',label:'River'},
  {value:'CREEK',label:'Creek'},
  {value:'BAY',label:'Bay'},
  {value:'SOUND',label:'Sound'},
  {value:'LAGOON',label:'Lagoon'},
  {value:'MARINA',label:'Marina'},
  {value:'INTRACOASTAL_WATERWAY',label:'Intracoastal Waterway'},
  {value:'HARBOR',label:'Harbor'},
  {value:'GULF',label:'Gulf'},
  {value:'WETLANDS',label:'Wetlands'},
  {value:'BAYOU',label:'Bayou'},
  {value:'MARSH',label:'Marsh'},
  {value:'COMMERCIAL',label:'Commercial'},
  {value:'PARKING_LOT',label:'Parking Lot'},
  {value:'INDUSTRIAL',label:'Industrial'},
  {value:'MILITARY_BASE',label:'Military Base'},
  {value:'RAILROAD',label:'Railroad'},
  {value:'INTERSTATE',label:'Interstate'},
  {value:'ELEVATED_OVERPASS',label:'Elevated Overpass'},
  {value:'PASTURES_FIELDS_ETC',label:'Pasture Fields Etc'},
  {value:'AGRICULTURAL_FARM_ETC',label:'Agricultural Farm Etc'},
  {value:'DESERT',label:'Desert'},
  {value:'CANYON',label:'Canyon'},
  {value:'VALLEY',label:'Valley'},
  {value:'COUNTRYSIDE',label:'Countryside'},
  {value:'RAVINE',label:'Ravine'},
  {value:'CITY_SKYLINE',label:'City Skyline'},
  {value:'GOLF_COURSE',label:'Golf Course'},
  {value:'PARK',label:'Park'},
  {value:'APARTMENT_COMPLEX',label:'Apartment Complex'},
  {value:'WINDMILL_WINDFARM',label:'Windmill Windfarm'},
  {value:'OVERHEAD_ELECTRIC_POWER_TRANSMISSION_LINE',label:'Overhead Electric Power Transmission Line'},
  {value:'SCHOOL',label:'School'}
]

const featureTypeEnum = [
  {value:'ORNATE_LANDSCAPING', label:'Ornate Landscaping'},
  {value:'OUTDOOR_KITCHEN', label:'Outdoor Kitchen'},
  {value:'INGROUND_POOL', label:'Inground Pool'},
  {value:'INGROUND_HOTTUB', label:'Inground Hottub'},
  {value:'SPORTS_COURT', label:'Sports Court'},
  {value:'SAUNA', label:'Sauna'},
  {value:'GAZEBO', label:'Gazebo'},
  {value:'PATIO', label:'Patio'},
  {value:'DECK', label:'Deck'},
  {value:'BALCONY', label:'Balcony'},
  {value:'UNCOVERED_PORCH', label:'Uncovered Porch'},
  {value:'COVERED_PORCH', label:'Covered Porch'},
  {value:'ENCLOSED_PORCH', label:'Enclosed Porch'},
  {value:'WRAP_AROUND_PORCH', label:'Wrap Around Porch'},
  {value:'STOOP', label:'Stoop'},
  {value:'FIREPIT', label:'Firepit'},
  {value:'OUTDOOR_FIREPLACE', label:'Outdoor Fireplace'},
  {value:'OTHER', label:'Other'},
  {value:'NONE', label:'None'},
  {value:'CARPORT', label:'Carport'},
  {value:'ABOVE_GROUND_POOL', label:'Above Ground Pool'}
]
const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const CondoUnitViewFeaturesHeatingCooling  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                switch(field){
                  case 'imageView':
                    let views = newUPD.property.buildings[props.index].units[props.index2].unitView.views.slice()
                    let target1 = views[index][field]?views[index][field]:[];
                    target1.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:newUPD.property.buildings[props.index].units[props.index2].unitView.views[index].ID, description:description});
                    views[index][field] = target1;
                    newUPD.property.buildings[props.index].units[props.index2].unitView.views = views;
                    break;
                  case 'imageFeatureType':
                    let unitFeatures = newUPD.property.buildings[props.index].units[props.index2].unitFeatures.slice()
                    let target2 = unitFeatures[index][field]?unitFeatures[index][field]:[];
                    target2.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:newUPD.property.buildings[props.index].units[props.index2].unitFeatures[index].ID, description:description});
                    unitFeatures[index][field] = target2;
                    newUPD.property.buildings[props.index].units[props.index2].unitFeatures = unitFeatures;
                    break;
                  default:
                    break;
                }
                
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateFileDescription = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    switch(field){
      case 'imageView':
        let views = newUPD.property.buildings[props.index].units[props.index2].unitView.views.slice()
        let target1 = views[index][field]?views[index][field]:[];
        if(target1 && target1[index2])
          target1[index2].description = description;

        newUPD.property.buildings[props.index].units[props.index2].unitView.views = views;
        break;
      case 'imageFeatureType':
        let unitFeatures = newUPD.property.buildings[props.index].units[props.index2].unitFeatures.slice()
        let target2 = unitFeatures[index][field]?unitFeatures[index][field]:[];
        if(target2 && target2[index2])
          target2[index2].description = description;
        newUPD.property.buildings[props.index].units[props.index2].unitFeatures = unitFeatures;
        break;
      default:
        break;
    }

    props.update(newUPD);
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    switch(field){
      case 'imageView':
        let views = newUPD.property.buildings[props.index].units[props.index2].unitView.views.slice()
        let target1 = views[index][field].slice();
        let targetToDelete1 = target1[index2];
        if(targetToDelete1.ID && targetToDelete1.ID!==-1){
          let successCallBack = ()=>{
            target1.splice(index2, 1);
            views[index][field] = target1;
            newUPD.property.buildings[props.index].units[props.index2].unitView.views = views;
            props.update(newUPD);
          };
          successCallBack = successCallBack.bind(this);
          deletePhoto(targetToDelete1.ID, props, successCallBack);
        }
        else{
          target1.splice(index2, 1);
          views[index][field] = target1;
          newUPD.property.buildings[props.index].units[props.index2].unitView.views = views;
          props.update(newUPD);
        }
        break;
      case 'imageFeatureType':
        let unitFeatures = newUPD.property.buildings[props.index].units[props.index2].unitFeatures.slice()
        let target2 = unitFeatures[index][field].slice();
        let targetToDelete2 = target2[index2];
        if(targetToDelete2.ID && targetToDelete2.ID!==-1){
          let successCallBack = ()=>{
            target2.splice(index2, 1);
            unitFeatures[index][field] = target2;
            newUPD.property.buildings[props.index].units[props.index2].unitFeatures = unitFeatures;
            props.update(newUPD);
          };
          successCallBack = successCallBack.bind(this);
          deletePhoto(targetToDelete2.ID, props, successCallBack);
        }
        else{
          target2.splice(index2, 1);
          unitFeatures[index][field] = target2;
          newUPD.property.buildings[props.index].units[props.index2].unitFeatures = unitFeatures;
          props.update(newUPD);
        }
        break;
      default:
        break;
    }
  }

  const getUnitViewDescriptionTypeLabel = (value)=>{
    for(let i=0;i<unitViewDescriptionTypeEnum.length;i++){
      if(unitViewDescriptionTypeEnum[i].value===value)
        return unitViewDescriptionTypeEnum[i].label;
    }

    return value;
  }

  const getFeatureTypeLabel = (value)=>{
    for(let i=0;i<featureTypeEnum.length;i++){
      if(featureTypeEnum[i].value===value)
        return featureTypeEnum[i].label;
    }

    return value;
  }

  const updateUnitViewFeatureDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.buildings[props.index].units[props.index2].unitView.views?newUPD.property.buildings[props.index].units[props.index2].unitView.views:null;
    views[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].unitView.views = views;
    props.update(newUPD);
  }

  const updateUnitFeatureDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let unitFeatures = newUPD.property.buildings[props.index].units[props.index2].unitFeatures.slice()
    unitFeatures[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].unitFeatures = unitFeatures;
    props.update(newUPD);
  }

  const updateUnitViewDescriptionType = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.buildings[props.index].units[props.index2].unitView.views?newUPD.property.buildings[props.index].units[props.index2].unitView.views:null;
    if(value==='NONE_NOTABLE'){
      views = [{unitViewDescriptionType:value}];
    }
    else{
      for(let i=0;i<views.length;i++){
        if(views[i].unitViewDescriptionType==='NONE_NOTABLE'){
          views = [];
          break;
        }
      }

      views.push({unitViewDescriptionType:value, imageView:[]});
    }
    
    newUPD.property.buildings[props.index].units[props.index2].unitView.views = views;
    props.update(newUPD);
  }

  const removeUnitViewDescriptionType = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.buildings[props.index].units[props.index2].unitView.views?newUPD.property.buildings[props.index].units[props.index2].unitView.views.slice():null;
    views.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].unitView.views = views;
    props.update(newUPD);
  }

  const updateFeatureType = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let unitFeatures = newUPD.property.buildings[props.index].units[props.index2].unitFeatures?newUPD.property.buildings[props.index].units[props.index2].unitFeatures.slice():[];

    if(value==='NONE'){
      unitFeatures = [{featureType:'NONE'}];
    }
    else{
      for(let i=0;i<unitFeatures.length;i++){
        if(unitFeatures[i].featureType==='NONE_NOTABLE'){
          unitFeatures = [];
          break;
        }
      }

      unitFeatures.push({featureType:value, imageFeatureType:[]});
    }
    
    newUPD.property.buildings[props.index].units[props.index2].unitFeatures = unitFeatures;
    props.update(newUPD);
  }

  const removeFeatureType = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let unitFeatures = newUPD.property.buildings[props.index].units[props.index2].unitFeatures?newUPD.property.buildings[props.index].units[props.index2].unitFeatures.slice():null;
    unitFeatures.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].unitFeatures = unitFeatures;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return <div>
    <label>{!props.disabled?<font color="red">*</font>:null}Indicate the view or views that best describes the unit view. {generateTooltip('unitViewDescriptionType', 'Indicate the view or views that best describes the unit view. Select the most notable view first, followed by any other impactful views. The view identified for condominium unit must be determined from the unit itself.')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].units[props.index2].unitView.views && props.upd.property.buildings[props.index].units[props.index2].unitView.views.length>0?" ":""}
      onChange={(v)=>updateUnitViewDescriptionType(v)}
      options={unitViewDescriptionTypeEnum}
    />
    {
      props.upd.property.buildings[props.index].units[props.index2].unitView.views.map(
        (view, index)=>{
          if(view.unitViewDescriptionType==='NONE_NOTABLE'){
            return <div key={index} style={{marginTop:'15px'}}>
              <b>None Notable</b>
            </div>
          }
          return <div key={index}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeUnitViewDescriptionType(index)}/>{view.ID} {getUnitViewDescriptionTypeLabel(view.unitViewDescriptionType)}</CardHeader>
              <CardBody>
                <label>{!props.disabled?<font color="red">*</font>:null}How would you characterize the unit's exposure to this view? Select the option that best describes it. {generateTooltip('unitViewQuality'+index,'Select the best option to further describe the selected view. ')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={view.unitViewQuality}
                  onChange={(v)=>updateUnitViewFeatureDetail(index, 'unitViewQuality', v)}
                  options={[{label:"Full", value:"FULL"}, {label:"Partial", value:"PARTIAL"}]}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Provide a description of the view(s) selected.  {generateTooltip('unitViewDescriptionDetails'+index, 'Provide a description of the view.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={view.unitViewDescriptionDetails} onChange={(e)=>updateUnitViewFeatureDetail(index,'unitViewDescriptionDetails', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of notable view(s)</label>
                <br/>
                <input
                  tabIndex={-1}
                  autoComplete="off"
                  style={{ opacity: 0, height: 0, width:0 }}
                  value={view.imageView&&view.imageView.length>0?" ":""}
                  required={!props.disabled}
                />
                <div>
                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageView', 'CONDO_VIEW', 0)}} className="my-dropzone">
                  {
                    ({getRootProps, getInputProps}) => (
                      <div
                        {...getRootProps({
                          className: 'my-dropzone',
                        })}
                      >
                        <input {...getInputProps()} />
                        <center>Choose files to upload</center>
                      </div>
                    )
                  }
                  </Dropzone>
                  {
                    !view.imageView?null:view.imageView.map(
                      (photo, index2)=>{
                        return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                          <div>
                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageView',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                          </div>
                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                          <div style={{marginTop:'5px'}}/>
                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageView', e.target.value)}/>
                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                        </div>
                      }
                    )
                  }
                </div>
              </CardBody>
            </Card>
            <br/>
          </div>;
        }
      )
    }
    <br/>
    <label>{!props.disabled?<font color="red">*</font>:null}Select the feature(s) specific to the unit. {generateTooltip('featureType', 'Indicate all features specific to the unit. If there are no additional unit features, "None" must be selected. ')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].units[props.index2].unitFeatures && props.upd.property.buildings[props.index].units[props.index2].unitFeatures.length>0?" ":""}
      onChange={(v)=>updateFeatureType(v)}
      options={featureTypeEnum}
    />
    {
      !props.upd.property.buildings[props.index].units[props.index2].unitFeatures?null:props.upd.property.buildings[props.index].units[props.index2].unitFeatures.map(
        (featureType, index)=>{
          if(featureType.featureType==='NONE'){
            return <div key={index} style={{marginTop:'15px'}}>
              <b>None</b>
            </div>
          }
          return <div key={index}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFeatureType(index)}/>{getFeatureTypeLabel(featureType.featureType)}</CardHeader>
              <CardBody>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of unit's features</label>
                <br/>
                <input
                  tabIndex={-1}
                  autoComplete="off"
                  style={{ opacity: 0, height: 0, width:0 }}
                  value={featureType.imageFeatureType&&featureType.imageFeatureType.length>0?" ":""}
                  required={!props.disabled}
                />
                <div>
                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageFeatureType', 'FEATURE_TYPE', 0)}} className="my-dropzone">
                  {
                    ({getRootProps, getInputProps}) => (
                      <div
                        {...getRootProps({
                          className: 'my-dropzone',
                        })}
                      >
                        <input {...getInputProps()} />
                        <center>Choose files to upload</center>
                      </div>
                    )
                  }
                  </Dropzone>
                  {
                    !featureType.imageFeatureType?null:featureType.imageFeatureType.map(
                      (photo, index2)=>{
                        return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                          <div>
                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageFeatureType',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                          </div>
                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                          <div style={{marginTop:'5px'}}/>
                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageFeatureType', e.target.value)}/>
                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                        </div>
                      }
                    )
                  }
                </div>
              </CardBody>
            </Card>
            <br/>
          </div>
        }
      )
    }
  </div>
}


export default CondoUnitViewFeaturesHeatingCooling;